<template>
  <div class="button-like"
    :class="{ '_is-liked': isLiked }"
    @click="$emit('like-card')">
    <slot v-if="slotBefore" />
    <AppSvg class="button-like__icon"
      id="heart" />
    <AppSvg class="button-like__icon button-like__icon_hover"
      id="heart-hover" />
    <slot v-if="slotAfter" />
  </div>
</template>

<script>
import { useFavoritesStore } from "@/store/store.js";
import { computed } from "vue";

export default {
  name: "ButtonLike",

  props: {
    slotBefore: {
      type: Boolean,
      default: false,
    },
    slotAfter: {
      type: Boolean,
      default: false,
    },
    alias: {
      type: String,
    },
  },
  setup(props) {
    const store = useFavoritesStore();
    let isLiked = false;
    isLiked = computed(() => store.getIsLiked(props.alias));
    return { isLiked };
  },
};
</script>

<style lang="scss" scoped>
.button-like {
  $c: &;
  display: flex;
  align-items: center;
  width: 46px;
  height: 46px;
  transition: lor 0.25s ease-out;
  cursor: pointer;
  position: relative;

  &__icon {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: visible;
    opacity: 1;
    transition: opacity 0.3s ease;

    &_hover {
      opacity: 0;
    }
  }

  &:hover {
    color: $color_primary;

    #{$c}__icon {
      opacity: 0;

      &_hover {
        opacity: 1;
      }
    }
  }

  .group {
    transform: translate(-16px, -18px);
  }

  .heart {
    transform-origin: center;
    animation: animateHeartOut 0.3s linear forwards;
  }

  .main-circ {
    transform-origin: 29.5px 29.5px;
  }

  &._is-liked {
    color: $color_primary;

    .heart {
      transform: scale(0.2);
      fill: $color_primary;
      animation: animateHeart 0.3s linear forwards 0.25s;
    }

    .main-circ {
      transition: all 2s;
      animation: animateCircle 0.3s linear forwards;
      opacity: 1;
    }

    .particle_1 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(0, -30px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(10px, -50px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_2 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(30px, -15px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(60px, -15px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_3 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(30px, 0px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(60px, 10px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_4 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(30px, 15px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(40px, 50px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_5 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(-10px, 20px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(-60px, 30px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_6 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(-30px, 0px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(-60px, -5px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_7 {
      opacity: 1;
      transition: 0.1s all 0.3s;

      .oval_1 {
        transform: scale(0) translate(-30px, -15px);
        transform-origin: 0 0 0;
        transition: 0.5s transform 0.3s;
      }

      .oval_2 {
        transform: scale(0) translate(-55px, -30px);
        transform-origin: 0 0 0;
        transition: 1.5s transform 0.3s;
      }
    }

    .particle_2 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }

    .particle_3 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }

    .particle_4 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }

    .particle_5 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }

    .particle_6 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }

    .particle_7 {
      opacity: 1;
      transition: 0.1s opacity 0.3s;
    }
  }

  @keyframes animateCircle {
    40% {
      transform: scale(10);
      opacity: 1;
      fill: #dd4688;
    }

    55% {
      transform: scale(11);
      opacity: 1;
      fill: #d46abf;
    }

    65% {
      transform: scale(12);
      opacity: 1;
      fill: #cc8ef5;
    }

    75% {
      transform: scale(13);
      opacity: 1;
      fill: transparent;
      stroke: #cc8ef5;
      stroke-width: 0.5;
    }

    85% {
      transform: scale(17);
      opacity: 1;
      fill: transparent;
      stroke: #cc8ef5;
      stroke-width: 0.2;
    }

    95% {
      transform: scale(18);
      opacity: 1;
      fill: transparent;
      stroke: #cc8ef5;
      stroke-width: 0.1;
    }

    100% {
      transform: scale(19);
      opacity: 1;
      fill: transparent;
      stroke: #cc8ef5;
      stroke-width: 0;
    }
  }

  @keyframes animateHeart {
    0% {
      transform: scale(0.2);
    }

    40% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes animateHeartOut {
    0% {
      transform: scale(1.4);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
